// extracted by mini-css-extract-plugin
module.exports = {"root":"WebinarSpeaker_root__XFouR","imageWrapper":"WebinarSpeaker_imageWrapper__1BpG8","name":"WebinarSpeaker_name___Psu0","subline":"WebinarSpeaker_subline__R_kh_"};